export class RequestReclamationDeviceDto {
    reclamationProductGroupId: number;
    reclamationDeviceId: number;
}